
(function() {
    //As an optional paramter to show Released or Releasing text in front of the date.
    //Example no text {{movie.OpeningDate | MonthDayFormatter}}
    //Example no text {{movie.OpeningDate | MonthDayFormatter: [false]}}
    //Example with text, {{movie.OpeningDate | MonthDayFormatter: [true]}}
    function MonthDayFormatter() {
        return function(datetime, includeText) {
            if (_.isNull(datetime) || _.isUndefined(datetime)) {
                return includeText ? "Releasing: TBA" : "TBA";
            } else {
                var releasingText = "";
                datetime = moment(datetime);
                if (includeText) {
                    var today = moment();
                    var dateDifference = datetime.diff(today);
                    releasingText =
                        dateDifference <= 0 ? "Released: " : "Releasing: ";
                }
                return (releasingText) + moment(datetime).format("MMM. Do");
            }
        };
    }
    MonthDayFormatter.$inject = [];
    angular
        .module("cstudioApp.filters")
        .filter("MonthDayFormatter", MonthDayFormatter);
})();